<div class="toast-container" role="status" aria-live="polite">
    @for (alert of alerts$ | async; track alert) {
        <div class="toast" [class]="'toast--' + alert.context" [class.toast--exiting]="alert.exiting">
            <div class="toast__icon">
                @if (alert.context === "danger") { <i class="fa fa-exclamation"></i> }
                @if (alert.context === "success") { <i class="fa fa-check"></i> }
                @if (alert.context === "info" || alert.context === "primary") { <i class="fa fa-info"></i> }
                @if (alert.context === "warning") { <i class="fa fa-warning"></i> }
            </div>
            <div class="toast__body" [innerHTML]="alert.message"></div>
            @if (alert.dismissible) {
                <button class="toast__close" aria-label="Dismiss notification" (click)="closeAlert(alert)">
                    <span class="fa fa-close"></span>
                </button>
            }
        </div>
    }
</div>
